<template>
    <div class="flex flex-col items-center">
        {{ $t('A Generic Choose-One Question') }}

        <div class="flex my-4">
            <button class="mx-2" @click="answer('a')">
                {{ $t('Choice A') }}
            </button>

            <button class="mx-2" @click="answer('b')">
                {{ $t('Choice B') }}
            </button>

            <button class="mx-2" @click="answer('c')">
                {{ $t('Choice C') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {},
    },

    methods: {
        answer(value) {
            this.$emit('answered', value);
        },
    },
}
</script>
